export { default } from "./src/download-row";

export type { UniformDownloadRowProps } from "./src/download-row";
